export const getParamFromURL = (params: string, key: string) => {
    const query = new URLSearchParams(params);
    return query.get(key);
};
